package gr.tech.GRAttestation.infrastructure.session

import androidx.compose.runtime.mutableStateOf
import gr.tech.GRAttestation.models.user.UserPreview

object AdminUserSession {
    var info = mutableStateOf<UserPreview?>(null)
    val checked = mutableStateOf(false)
    
    /* ---------------- */
    
    fun isLoggedIn(): Boolean {
        return checked.value && info.value != null
    }

    fun setLoggedOut() {
        info.value = null
        checked.value = false
    }
}